import { useQuery } from '@tanstack/react-query';
import { FilePdf, FileVideo, Image as ImageIcon } from '@phosphor-icons/react';
import type { BriefAsset } from '@mybusinessmate/schema';
import { assetUrlQuery } from '../../lib/asset-url';
import { cx } from '../../lib/cx';
import { Icon } from '../Icon';

const iconFor = (contentType: string) =>
  contentType.startsWith('video/') ? FileVideo : contentType === 'application/pdf' ? FilePdf : ImageIcon;

/**
 * A stored file as a picture: images are shown through a signed link, anything else (video, PDF, zip) as its icon.
 * Fills its parent, so the parent sets the size, the radius and what is drawn on top.
 */
export function AssetImage({ asset, className }: { asset: BriefAsset; className?: string }) {
  const isImage = asset.contentType.startsWith('image/');
  const { data: url } = useQuery({ ...assetUrlQuery(asset.key), enabled: isImage });
  return url ? (
    <img src={url} alt={asset.label ?? asset.name} className={cx('size-full object-cover', className)} />
  ) : (
    <span className={cx('flex size-full items-center justify-center text-text-secondary', className)}>
      <Icon icon={iconFor(asset.contentType)} size="xl" />
    </span>
  );
}
